import { getApi, postApi, putApi } from "../apiCall";

export const alterTableRa = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/update-times/${id}`;
  return putApi(url, payload);
};

export const bucketFillBefore = () => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/bucketFill/fillAndShortlistForRA`;
  return getApi(url);
};

export const bucketFillAfter = () => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/bucketFill/fillAndShortlistForRAAuctionStage`;
  return getApi(url);
};
